"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enrichLCPMeasurement = enrichLCPMeasurement;
function isLCPMeasurementEvent(event) {
  var _event$payload, _event$payload2;
  return event.type === 'measurement' && ((_event$payload = event.payload) === null || _event$payload === void 0 ? void 0 : _event$payload.type) === 'web-vitals' && !!((_event$payload2 = event.payload) !== null && _event$payload2 !== void 0 && (_event$payload2 = _event$payload2.values) !== null && _event$payload2 !== void 0 && _event$payload2.lcp);
}
function getTargetElement(event) {
  var _event$payload3;
  var element = (_event$payload3 = event.payload) === null || _event$payload3 === void 0 || (_event$payload3 = _event$payload3.context) === null || _event$payload3 === void 0 ? void 0 : _event$payload3.element;
  if (!element) {
    return undefined;
  }
  try {
    var _document$querySelect;
    return (_document$querySelect = document.querySelector(element)) !== null && _document$querySelect !== void 0 ? _document$querySelect : undefined;
  } catch (_unused) {
    // Handle invalid CSS selectors
    return undefined;
  }
}
function getImageUrl(element) {
  // Check if it's an img tag with src attribute
  if (element.tagName === 'IMG' && element instanceof HTMLImageElement) {
    return element.src;
  }
  if (element.tagName === 'VIDEO' && element instanceof HTMLVideoElement) {
    return element.src;
  }

  // Check for background-image in computed styles
  var computedStyle = window.getComputedStyle(element);
  var backgroundImage = computedStyle.backgroundImage;
  if (backgroundImage && backgroundImage !== 'none') {
    // Extract URL from background-image: url("...") or url(...)
    var urlMatch = backgroundImage.match(/url\(['"]?([^'"]+)['"]?\)/);
    if (urlMatch && urlMatch[1]) {
      return urlMatch[1];
    }
  }
  return undefined;
}

/**
 * Grafana Faro event enrichment function for LCP measurement events.
 * Adds the immediate_id, tag_name, and text_content to the event context.
 * Reference: https://grafana.com/docs/grafana-cloud/monitor-applications/frontend-observability/instrument/web-vitals/#largest-contentful-paint-lcp
 */
function enrichLCPMeasurement(event) {
  if (isLCPMeasurementEvent(event)) {
    var _targetElement$getBou, _targetElement$getBou2;
    var targetElement = getTargetElement(event);
    if (!targetElement) {
      return event;
    }

    // Get element dimensions for display size
    var _ref = (_targetElement$getBou = targetElement === null || targetElement === void 0 || (_targetElement$getBou2 = targetElement.getBoundingClientRect) === null || _targetElement$getBou2 === void 0 ? void 0 : _targetElement$getBou2.call(targetElement)) !== null && _targetElement$getBou !== void 0 ? _targetElement$getBou : {},
      height = _ref.height,
      width = _ref.width;
    if (event.payload && 'context' in event.payload && event.payload.context) {
      var imageUrl = getImageUrl(targetElement);
      if (imageUrl) {
        event.payload.context.url = imageUrl;
      }
      if (targetElement !== null && targetElement !== void 0 && targetElement.className) {
        event.payload.context.class = targetElement === null || targetElement === void 0 ? void 0 : targetElement.className;
      }
      if (height) {
        event.payload.context.height = height.toString();
      }
      if (width) {
        event.payload.context.width = width.toString();
      }
      if (targetElement.fetchPriority) {
        event.payload.context.fetch_priority = targetElement.fetchPriority;
      }
    }
  }
  return event;
}